import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import ActionTypes from '../constants'
import { GetExcludedGamesPayload, ExcludedGamesState } from '../models'

import { EXCLUDED_GAMES } from './api.routes'

const apiService: RestApiService = Container.get(RestApiService)

export const getExcludedGamesThunk = createAsyncThunk(
  ActionTypes.GET_EXCLUDED_GAMES,
  async (payload: GetExcludedGamesPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'GET',
        endpoint: EXCLUDED_GAMES.GET_EXCLUDED_GAMES,
        queries: jsonToQueryString(payload),
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: any = await apiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      let responseData = response

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return responseData
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const getExcludedGamesExtraReducer = (
  builder: ActionReducerMapBuilder<ExcludedGamesState>,
) => {
  builder.addCase(getExcludedGamesThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(getExcludedGamesThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.excludedGames = payload
  })
}

export default getExcludedGamesExtraReducer
